import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { telemetry } from './telemetry'

/**
 * QueryClient global.
 *
 * Decisões:
 * - staleTime 2min: dados do portal mudam pouco em uma sessão típica.
 * - gcTime 10min: cache vivo pra navegação rápida entre páginas.
 * - retry 2 com backoff exponencial: tolera blip de rede sem o user esperar 30s.
 * - networkMode 'always': queries não pausam quando navigator.onLine reporta
 *    offline (Supabase pode estar vivo via WS). Evita "tela em branco ao voltar do sleep".
 * - refetchOnWindowFocus false: portal é visualização, não dashboard ao vivo.
 * - QueryCache.onError: telemetria centralizada de falhas.
 */
const RETRY_BACKOFF = (attempt) => Math.min(1000 * 2 ** attempt, 8000)

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      telemetry.captureException(error, {
        queryKey: query.queryKey,
        scope: 'react-query.query',
      })
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      telemetry.captureException(error, {
        mutationKey: mutation.options.mutationKey,
        scope: 'react-query.mutation',
      })
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2,
      gcTime: 1000 * 60 * 10,
      retry: 2,
      retryDelay: RETRY_BACKOFF,
      refetchOnWindowFocus: false,
      networkMode: 'always',
    },
    mutations: {
      retry: 0,
      networkMode: 'always',
    },
  },
})
